import { render } from "./CustomerImage.vue?vue&type=template&id=86a401be"
import script from "./CustomerImage.vue?vue&type=script&lang=js"
export * from "./CustomerImage.vue?vue&type=script&lang=js"

import "./CustomerImage.vue?vue&type=style&index=0&id=86a401be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__